'use strict';/* global define */define('modules/finest-anchor/services/finest-anchor/index',['require','exports','module'],function(require,exports,module){'use strict';// @ngInject
     factory.$inject = ["$document", "$timeout", "$q", "AnimatedScrollTo"];
function factory($document,$timeout,$q,AnimatedScrollTo){// jshint validthis:true
// jshint latedef:false
return{blink:blink};// ---
/**
     * Scroll to a given element on
     * the page and give it the animation class of your choice
     *
     * @param  {String} hash    - ID of the given element
     * @param  {Object} options - Extensible object containing the animate class
     *
     * @return {Promise}        - promise
     *
     * @tested
     */function blink(hash,options){var defered=$q.defer();var element=$document[0].getElementById(hash);if(element){AnimatedScrollTo.scrollTo(element).then(function(){element.classList.add(options.animationType);defered.resolve();}).finally(function(){$timeout(function(){element.classList.remove(options.animationType);},1000);});}return defered.promise;}}module.exports=factory;});
